import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Message, Button, Container } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectPriseEnChargeGrid } from "../../features/PriseEnCharge/PriseEnChargeSlice";

import axios from "axios";
import { server } from "../../App";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"


function DeleteOneBloc() {
  const [isdeleted, setIisdeleted] = useState(false);
  const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);

  const { priseEnChargeData } = PriseEnChargeState;
  const {

    prenom,
    nom,

    date_Lisible,
    idbloc,

  } = priseEnChargeData;


  // sessionStorage.setItem("ID_PriseEnCharge", idPriseEnCharge);

  const deletehandler = async () => {
    await axios({
      method: "delete",
      responseType: "json",
      url: `${server}Bloc/${idbloc}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        // dispatch(form_load(initialState));
        toast.success("Success", {
          position: toast.POSITION.TOP_CENTER,
        });
        setIisdeleted(true);
      })
      .catch((err) =>
        toast.error("error", {
          position: toast.POSITION.TOP_CENTER,
        })
      );
  };

  return (
    <Fragment>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          {!isdeleted ? (
            <Message color="orange">
              <Message.Header>
                Voulez-vous supprimer {nom} {prenom} du programme : {date_Lisible} ?{" "}
              </Message.Header>
            </Message>
          ) : (
            <Message color="green">
              <Message.Header>
                {nom} {prenom} a été supprimé avec succès du programme : {date_Lisible}
              </Message.Header>
            </Message>
          )}
          {!isdeleted ?
            <Button
              floated="right"
              negative
              onClick={() => {
                deletehandler();
              }}
            >
              Supprimer
            </Button>
            :
            ""

          }

          <Link to="/bloc_Main">
            <Button floated="right" color="blue">
              retour
            </Button>
          </Link>
        </Container>
      </div>
      <SpeedDialComponent />
    </Fragment>
  );
}

export default DeleteOneBloc;
